<div class="container container-shadow my-4" *ngIf="vendorLoading">
  <div class="text-center py-5">
    <i class="fas fa-spinner fa-3x fa-fw fa-pulse"></i>
  </div>
</div>
<div class="container container-shadow my-4" *ngIf="!vendorLoading">
  <h2 class="pt-4 text-center">Editing Vendor</h2>
  <hr class="mt-1 mb-3" />
  <div class="row">
    <div class="col-md-10 ml-md-auto mr-md-auto col-lg-8 px-md-0 px-sm-3">
      <app-vendor-form [vendor]="vendor"></app-vendor-form>
    </div>
  </div>
</div>
